import React, { useMemo } from 'react';
import PageSidebar, { SidebarSection } from '../PageSidebar';
import { McpToolCategory } from '../../../hooks/useMcpTools';

interface SidebarProps {
  expandedSection: Set<string>;
  activeSection: string;
  activeContent: string;
  onToggleSection: (section: string) => void;
  onMenuItemClick: (contentId: string) => void;
  onScrollSync?: (contentId: string) => void;
  theme: 'light' | 'dark';
  mcpToolCategories: McpToolCategory[];
  isScrollingRef?: React.RefObject<boolean>;
}

const MCP_SERVER_SECTION: SidebarSection = {
  key: 'mcp-server',
  label: 'MCP Server',
  items: [
    { label: 'Model Context Protocol', id: 'model-context-protocol' },
    { label: 'Key MCP Features', id: 'key-mcp-features' },
    { label: 'What is MCP ?', id: 'what-is-mcp' },
    { label: 'Availity MCP Server', id: 'availity-mcp-server' },
    { label: 'Why Choose MCP ?', id: 'why-choose-mcp' },
    { label: 'Supported APIs', id: 'supported-apis' },
    { label: 'Getting Started', id: 'getting-started-with-mcp' },
    { label: 'Example Workflow', id: 'example-workflow' },
  ],
};

const Sidebar = ({ mcpToolCategories, ...props }: SidebarProps): JSX.Element => {
  const sections = useMemo<SidebarSection[]>(() => [
    MCP_SERVER_SECTION,
    { key: 'mcp-tools', label: 'MCP Tools', items: mcpToolCategories.map((cat) => ({ label: cat.category, id: cat.id })) },
  ], [mcpToolCategories]);

  return <PageSidebar {...props} sections={sections} />;
};

export default Sidebar;
